<template>
  <div class="Overview">
    <div class="content" v-show="res">
      <template v-if="res.register_user">
        <h2>Overview Stats</h2>
        <div class="top">
          <!--  User Count  -->
          <!--        <div class="item" v-if="res.register_user" @click="onItemOpen()">-->
          <!--          <i class="el-icon-s-custom"></i>-->
          <!--          <div class="text">-->
          <!--            <p>Registered Users</p>-->
          <!--          </div>-->
          <!--          <div class="num">-->
          <!--            <p>{{res.register_user}}</p>-->
          <!--          </div>-->
          <!--        </div>-->
          <!--  Active Challenge Count  -->
          <div class="item" v-if="res.active_challenge!==false" @click="onNav('challenges','home')">
            <i class="el-icon-menu"></i>
            <div class="text">
              <p>Active Challenges</p>
            </div>
            <div class="num">
              <p>{{res.active_challenge}}</p>
            </div>
          </div>
          <!--  Listed Product Count  -->
          <div class="item" v-if="res.product_count!==false" @click="onNav('market','first')">
            <i class="el-icon-s-goods"></i>
            <div class="text">
              <p>Listed Products</p>
            </div>
            <div class="num">
              <p>{{res.product_count}}</p>
            </div>
          </div>
          <!--  Listed Vendor Count  -->
          <div class="item" v-if="res.vendor_count!==false" @click="onNav('vendors','first')">
            <i class="el-icon-s-shop"></i>
            <div class="text">
              <p>Listed Vendors</p>
            </div>
            <div class="num">
              <p>{{res.vendor_count}}</p>
            </div>
          </div>
          <!--  Revenue Info  -->
          <div class="item" v-if="res.total_revenue!==false" @click="onNav('orders','')">
            <i class="el-icon-s-data"></i>
            <div class="text">
              <p>Today's Revenue</p>
              <p>Total Revenue</p>
            </div>
            <div class="num">
              <p>￥{{res.today_revenue | roundNum(2)}}</p>
              <p>￥{{res.total_revenue | roundNum(2)}}</p>
            </div>
          </div>
          <!--  Pending Orders  -->
          <div class="item" v-if="res.pending_order!==false" @click="onNav('orders','')">
            <i class="el-icon-s-order"></i>
            <div class="text">
              <p>New Orders (Pending)</p>
            </div>
            <div class="num">
              <p>{{res.pending_order}}</p>
            </div>
          </div>

        </div>
        <h2>Shortcuts</h2>
        <div class="bottom">
          <div class="action" @click="onNav('challenges','create')">
            <p>Create Challenge</p>
            <i class="el-icon-circle-plus"></i>
          </div>
          <div class="action" @click="onNav('market','second')">
            <p>Create Product</p>
            <i class="el-icon-circle-plus"></i>
          </div>
          <div class="action" @click="onNav('vendors','second')">
            <p>Create Vendor</p>
            <i class="el-icon-circle-plus"></i>
          </div>
<!--          <div class="action">-->
<!--            <p>Create User</p>-->
<!--            <i class="el-icon-circle-plus"></i>-->
<!--          </div>-->
        </div>
      </template>
      <template v-else>
        <h2 v-if="res.vendor_created">Overview Stats</h2>
        <div class="top" v-if="res.vendor_created">
          <!--  Page View Count  -->
          <div class="item">
            <i class="el-icon-s-data"></i>
            <div class="text">
              <p>Total Page Views</p>
            </div>
            <div class="num">
              <p>{{res.vendor_pv}}</p>
            </div>
          </div>
          <!--  Unique View Count  -->
          <div class="item">
            <i class="el-icon-s-custom"></i>
            <div class="text">
              <p>Total Unique Views</p>
            </div>
            <div class="num">
              <p>{{res.vendor_uv}}</p>
            </div>
          </div>
          <!--  Review Rating  -->
          <div class="item">
            <i class="el-icon-star-on"></i>
            <div class="text">
              <p>Review Rating</p>
            </div>
            <div class="num">
              <p>{{res.vendor_review_rate}}</p>
            </div>
          </div>
        </div>
        <h2 v-if="res.vendor_created">Store Options</h2>
        <div class="top" v-if="res.vendor_created">
          <!--  Page View Count  -->
          <div class="item">
            <i class="el-icon-star-off"></i>
            <div class="text">
              <p>Rating</p>
            </div>
            <div class="num">
              <i :class="res.vendor_rate_enable?'el-icon-check':'el-icon-close'"></i>
            </div>
          </div>
          <!--  Unique View Count  -->
          <div class="item">
            <i class="el-icon-edit-outline"></i>
            <div class="text">
              <p>Comment</p>
            </div>
            <div class="num">
              <i :class="res.vendor_review_enable?'el-icon-check':'el-icon-close'"></i>
            </div>
          </div>
          <!--  Review Rating  -->
          <div class="item">
            <i class="el-icon-video-camera"></i>
            <div class="text">
              <p>Video</p>
            </div>
            <div class="num">
              <i :class="res.vendor_video_enable?'el-icon-check':'el-icon-close'"></i>
            </div>
          </div>
        </div>
        <div class="bottom" v-if="!res.vendor_created">
          <div class="action" @click="onNav('store','create')">
            <p>Create Store</p>
            <i class="el-icon-circle-plus"></i>
          </div>
        </div>
      </template>
    </div>

    <div class="review" v-if="res.register_user||res.vendor_created">
      <div class="header">
        <div class="title">Recent Reviews</div>
        <template v-if="res.register_user">
          <el-dropdown class="picker" @command="switchReviewType">
          <span class="el-dropdown-link">
            {{review_type | capCase}}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item class="item" command="product" icon="el-icon-s-goods">Products</el-dropdown-item>
              <el-dropdown-item class="item" command="vendor" icon="el-icon-s-shop">Vendors</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </div>


      <div class="body" @scroll="onScrollReview">
        <template v-if="res.register_user">
          <template v-if="product_review_list&&review_type==='product'">
            <Review v-for="review in product_review_list"
                    :key="review.review_id"
                    :review="review"></Review>
          </template>

          <p v-if="product_review_list.length===0&&review_type==='product'">No recent product review</p>
          <template v-if="vendor_review_list&&review_type==='vendor'">
            <Review v-for="review in vendor_review_list"
                    :key="review.review_id"
                    :review="review"></Review>
          </template>

          <p v-if="vendor_review_list.length===0&&review_type==='vendor'">No recent vendor review</p>
        </template>
        <template v-else>
          <template v-if="vendor_review_list&&review_type==='vendor'&&res.vendor_created">
            <Review
                v-for="review in vendor_review_list"
                :key="review.review_id"
                :review="review"></Review>
          </template>

          <p v-if="vendor_review_list.length===0&&review_type==='vendor'&&res.vendor_created">No recent review</p>
        </template>
      </div>

    </div>
  </div>
</template>

<script>
  import {homeInfo, recentReview} from '@/utils/api'
  import Review from '@/components/Review/Review'

  export default {
    props: {},
    components: {
      Review
    },
    data: () => {
      return {
        res: false,
        scroll_block: false,
        review_type: 'product',
        product_review_list: [],
        vendor_review_list: []
      }
    },
    beforeMount() {
      this.$showLoading('Loading');
      let name = this.$route.name;
      homeInfo(name).then(res => {
        if (res.errcode === 0) {
          this.res = res;
          if (!res.register_user) {
            this.review_type = 'vendor';
            if (res.vendor_created) {
              this.getRecentReview();
            }
          } else {
            this.getRecentReview();
          }
          this.$hideLoading()
        } else {
          this.$hideLoading();
          this.$message.error(res.errmsg);
          this.$router.replace('/login')
        }
      });
    },
    methods: {
      onNav(name, target) {
        this.$router.push({
          name: name,
          params: {
            target: target
          }
        })
      },

      onScrollReview(event) {
        let scroll_total = event.target.scrollHeight;
        let scroll_current = event.target.scrollTop + event.target.offsetHeight;
        let interval = 2000;
        if (scroll_total - scroll_current <= 20 && !this.scroll_block) {
          this.scroll_block = true;
          this.getRecentReview();
          setTimeout(() => {
            this.scroll_block = false;
          }, interval)
        }
      },
      switchReviewType(command) {
        this.review_type = command;
        this.getRecentReview()
      },
      getRecentReview() {
        let type = this.review_type;
        let list = type === 'product' ? this.product_review_list : this.vendor_review_list;
        let start = list.length;
        recentReview(type, null, start, 10).then(res => {
          if (res.errcode === 0) {
            if (type === 'product') {
              this.product_review_list = this.product_review_list.concat(res.review_list);
            } else {
              this.vendor_review_list = this.vendor_review_list.concat(res.review_list);
            }
          } else {
            this.$message.error(res.errmsg);
          }
        })
      }

    }


  };
</script>

<style lang="scss" scoped>
  @import "_Overview.scss";
</style>